import { Component, EventEmitter, Output, ViewChild, OnDestroy } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { ApplicationFacade, CardsNgrxFacade, CustomerCard } from '@ridango/components';
import { BaseComponent } from '@ridango/core';

@Component({
    selector: 'rwidget-card-remove-modal',
    templateUrl: './card-remove-modal.component.html',
    styleUrls: ['card-remove-modal.component.scss']
})
export class CardRemoveModalComponent extends BaseComponent implements OnDestroy {
    @Output() removeConfirm: EventEmitter<void> = new EventEmitter<void>();
    @ViewChild(IonModal) removeCardModal: IonModal;
    assetsPath$ = this.applicationFacade.assetsPath$;

    card: CustomerCard;

    constructor(
        private applicationFacade: ApplicationFacade,
        private cardsFacade: CardsNgrxFacade
    ) {
        super();
    }

    closeModal() {
        this.removeCardModal.dismiss(null, 'cancel');
    }

    openModal(card: CustomerCard) {
        this.card = card;
        this.removeCardModal.present();
    }

    removeCard() {
        this.removeConfirm.emit();
        this.closeModal();
        this.cardsFacade.deleteRelatedCard(this.card);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
